import React from 'react';

import {HStack} from '../../Stack';
import {useModal} from '../ModalProvider';

import {ModalFooterView} from './ModalFooter.styles';

import type {HTMLAttributes, SpringTooling} from '../../__SharedTypes';

export type ModalFooterProps = {
  /**
   * Contents of the Modal footer.
   */
  children?: React.ReactNode;
  /**
   * Whether the ModalFooter should have a border.
   */
  hasBorder?: boolean;
} & HTMLAttributes &
  SpringTooling;

export const ModalFooter = React.forwardRef<HTMLDivElement, ModalFooterProps>(
  ({children, hasBorder = false, ...props}, ref) => {
    const {setHasRenderedFooter} = useModal();

    React.useEffect(() => {
      setHasRenderedFooter(true);
      return () => {
        setHasRenderedFooter(false);
      };
    }, [setHasRenderedFooter]);

    return (
      <ModalFooterView
        {...props}
        data-modal-footer
        hasBorder={hasBorder}
        ref={ref}
      >
        <HStack justify="end">{children}</HStack>
      </ModalFooterView>
    );
  }
);

ModalFooter.displayName = 'ModalFooter';
ModalFooter.toString = ModalFooterView.toString;

export default ModalFooter;
